export default [
    {
        id: 1,
        name: "LPG masáže",
        text: `Pomerančová kůže neboli celulitida je typicky ženským problémem. Vyskytuje se v podobě tukových hrudek zejména v oblasti zadečku, stehen a bříška. Na naší klinice nabízíme odstranění celulitidy prostřednictvím komplexního Anticelulitidního programu. Tento program se skládá ze dvou vzájemně se podporujících částí. Léčby přístrojem LPG - cellu v kombinaci s aplikací tzv. Mezoterapie. <br/><br/>
           <h3>LPG - CELLU</h3><br/>
           Přístroj funguje na principu vysoce účinné podtlakové rotační masáže na kůži a v podkoží. Základem přístroje jsou dva válečky umístěné ve vzduchotěsné komůrce. Tyto válečky jezdí po problematických lokalitách na těle a díky působícímu podtlaku ji masírují. Tím se rozbíjejí pod kůží tukové shluky a tuk se spolu s mezibuněčnou tekutinou vyplavuje do lymfatických cév. Kůže se vyhlazuje a celulitida mizí. Po absolvování celé léčebné kůry dochází nejen ke znovuvytvoření hladkého reliéfu, ale často i k redukci objemu v ošetřovaných lokalitách a to o několik centimetrů. Ošetření provádí pouze personál, který se účastnil stáže ve firmě LPG ve francouzské Nice a byl tam také vyškolen. Přístroj LPG však má širší využití. Kromě vyhlazování kůže je vhodný i pro terapeutické masáže (masáže jizev a zhojených popálenin), pro sportovní masáže a relaxační masáže. Ošetření je nebolestivé a mělo by se provádět minimálně 2x týdně v počtu 10-15 ošetření.`,
        types: [
            {
                name: "Přístrojová podtlaková masáž LPG - CELLU (25 minut)",
                price: "500 Kč",
            }, {
                name: "Přístrojová podtlaková masáž LPG - CELLU (35 minut)",
                price: "750 Kč",
            }, {
                name: "Přístrojová podtlaková masáž LPG - CELLU (45 minut)",
                price: "1 000 Kč",
            }
        ]
    }, {
        id: 2,
        name: "Biostimulace I.",
        text: `Biostimulace je prováděna pomocí biostimulačního laseru. Ten dokáže řešit několik zdravotních problémů najednou - a to díky možnosti užití různé vlnové délky neboli barvy laserového paprsku. Povrchově působící biostimulační laser se využívá k regeneraci pleti, hojení zánětlivých ložisek, ran a jizev na kůži i jako účinný stimulátor zvýšení metabolismu a zlepšení imunitního systému (např. u oparu a jiných viróz). <br/>
           Působení hlouběji pronikajícího biostimulačního laseru napomáhá pacientům ke zmírnění nepříjemných pocitů a k rychlejšímu a lepšímu výsledku po operacích, proto je také podporou v pooperační léčbě. Velké uplatnění nachází i v rehabilitační péči a sportovním lékařství díky myorelaxačním účinkům (bolesti zad, patní ostruhy, tzv. tenisový loket atd.).`,
        types: [
            {
                name: "do 20 minut",
                price: "200 Kč",
            }, {
                name: "do 30 minut",
                price: "300 Kč",
            },
        ]
    }, {
        id: 3,
        name: "Biostimulace II.",
        text: `Biostimulační lasery nepoužíváme jen k doléčení pooperačních stavů, ale své místo mají i v rehabilitační péči a léčbě zánětlivých stavů pohybového systému po operacích nebo po úrazech. <br/>
           Možností jeho použití je ošetřování pacientů s tzv. patní ostruhou nebo tenisovým loktem. Jedná se o spíše chronické onemocnění zánětlivého původu a laser zde dokáže stimulovat organismus v dané lokalitě k potlačení zánětu a návratu k normální funkci. S tím souvisí i odstranění bolestivosti a eventuálního otoku. Nejnověji zavádíme i léčbu pomocí Tachyonové energie.`,
        types: [
            {
                name: "do 20 minut",
                price: "200 Kč",
            }, {
                name: "do 30 minut",
                price: "300 Kč",
            },
        ]
    }, {
        id: 4,
        name: "Léčba obezity",
        text: `Obezitou či nadváhou trpí v naší republice vysoké procento populace a boj s ní je mnohdy těžký a bez odborné pomoci takřka nemožný. Přitom je dokázáno, že u obézních pacientů je daleko vyšší riziko vzniku nádorových onemocnění dělohy, prsu, trávicího ústrojí, prostaty a také zvýšené riziko onemocnění kloubů a páteře. Po kouření představuje obezita druhou nejvýznamnější příčinu úmrtí. Tomu však lze předcházet adekvátní prevencí a účinnou léčbou. Proto nabízíme našim klientům spolupráci s obezitologem, který provádí odborné vyšetření a na základě něho pak pomáhá pacientům v boji s nadváhou. <br/><br/>
           <h3>Obezitologická péče zahrnuje:</h3><br/>
           <ul class="ul">
              <li>interní vyšetření,</li>
              <li>konzultace se zaměřením na životní styl a stravovací návyky,</li>
              <li>vyloučení endogenní příčiny obezity,</li>
              <li>dietetická opatření,</li>
              <li>eventuální medikaci dle individuálních potřeb pacienta,</li>
              <li>zavedení BIB žaludečního systému,</li>
              <li>aplikaci botulotoxinu do žaludku,</li>
              <li>možnost nastavení podpůrného cvičebního programu podle zdravotního stavu pacienta naším fyzioterapeutem.</li>
            </ul>
            <br><br>
            <h2>Bariatrická chirurgie</h2><br><br>
           <h3>BIB systém</h3><br/>
           se skládá z měkkého roztažitého balónku, umisťovací trubičky a plnícího systému. Po vstupním interním vyšetření a dále preventivním vyšetření jícnu a žaludku pomocí endoskopu zavede lékař BIB ústy přes jícen do žaludku. Polykání se usnadní anestetiky, která se aplikují povrchově, aby umrtvila oblast krku. BIB se zavádí v nejmenší vypuštěné podobě a po umístění v žaludku se ihned naplní sterilním fyziologickým roztokem. Naplněný balónek je příliš velký, aby postoupil do střev a bude volně plavat v žaludku. Doba zavádění je různá, obvykle 20 - 30 minut. Poté Vás bude lékař po krátkou dobu sledovat, než se vrátíte domů. <br/><br/> 
           <h4>Aplikace botulotoxinu do žaludku</h4>
           Endoskopickou metodou se aplikuje bezpečná dávka botulotoxinu do žaludku, přičemž dochází postupně ke zpomalení vyprazdňování obsahu žaludku, máte déletrvající pocit plnosti a sníží se tím objem přijímané potravy, což vede ke snížení hmotnosti. <br/><br/>
            <ul class="ul">
                <li>Efekt přetrvává 4 - 6 měsíců.</li>
                <li>Je nutné dodržovat dietní opatření.</li>
                <li>Váhový úbytek je 10 - 25 kg.</li>
            </ul><br>
            <h4>Tubulizace žaludku</h4>
            Tubulizace žaludku je chirurgické odstranění velkého zakřivení žaludku se zónou produkce takzvaných „hladových hormonů". Zbylý žaludek pak má podobu trubice. Tyto operace nutí nemocného k redukci objemu přijímané potravy a tím k úbytku nadváhy bez většího pocitu hladu. V odstraněné části žaludku jsou produkovány zažívací hormony, které způsobují pocit hladu. Po operaci nemocný nepociťuje úporný hlad při redukční dietě. <br/>
            K operaci jsou vhodní především klienti, jenž mají vyšší stupeň nadváhy (BMI je větší než 35 kg/m2), kteří se v minulosti již pokusili redukovat svoji nadváhu jinými léčebnými postupy, nebo kteří trpí některými přidruženými chorobami, způsobenými především jejich vysokou nadváhou.
`,
        types: [
            {
                name: "Konzultace s obezitologem",
                price: "300 Kč",
                vzp: " "
            }, {
                name: "Interní vyšetření s odběry krve",
                price: "500 Kč",
                vzp: "2 500 Kč"
            }, {
                name: "Bariatrická chir.: Zavedení žaludečního BIB systému",
                price: "35 000 Kč",
            }, {
                name: "Bariatrická chir.: Aplikace botulotoxinu do žaludku a sledování pacienta",
                price: "30 000 Kč",
            }, {
                name: "Bariatrická chir.: Tubulizace žaludku",
                price: "150 000 Kč",
            },
        ],
        doctors: [
            4
        ]
    }, {
        id: 5,
        name: "Laserové bělení zubů",
        text: `Bílé zuby jsou sice korunou zářivého úsměvu, řadu z nás však trápí nevhodné zabarvení zubní skloviny. To může mít příčinu v konzumaci pochutin, kávy nebo v kouření. Pigmenty, které se tímto na zubech vytváří, lze velmi účinně odstranit laserovým bělením zubů. <br/>
           Tato technika umožňuje vybělení zubů o 4 - 5 odstínů, aniž by docházelo k narušení zubní skloviny. Jedná se o kontrolovanou aplikaci intenzivně bělící látky na zuby. Tato látka proniká do povrchu zubu a chemicky reaguje s usazenými pigmenty. Výsledkem této reakce je rozložení pigmentů provázené „odbarvením", tedy zesvětlením zubu. <br/>
           Ordinační bělení spočívá ve vyčištění zubů, aplikaci ochranné hmoty na dásně a nanesení bělícího přípravku na zuby. Pro zvýšení účinku bělící látky používá lékař speciální lampu s modrým světlem. Celý proces trvá přibližně 60 až 90 minut. <br/>
           Zákrok je velmi šetrný a zubní sklovina se nenarušuje. Na domácí péči si může pacient zakoupit speciální domácí dobělovací set, zubní pasty nebo zubní tyčinky, které udržují a zlepšují bělost zubů. <br/><br/>
           <h3>Po bělení zubů laserem</h3><br/>
           Několik dnů po bělení zubů laserem je nutné se vyhýbat potravinám a nápojům s vysokou koncentrací barviv (červené víno, káva, čaj atd.), aby nedošlo k opětovnému zabarvení zubů. Do budoucna lze pak zbarvování zubů omezit používáním speciálních bělících zubních past, které vám doporučí lékař.`,
        types: [
            {
                name: "Cena",
                price: "4 500 Kč",
            },
        ]
    },
]



// WEBPACK FOOTER //
// ./src/texts/czech/procedures/procedures_6.js